/**
 * Strip HTML tags from a string and return cleaned text
 * @param html - HTML string to clean
 * @returns Clean text without HTML tags
 */
export const stripHtml = (html: string): string => {
  if (!html || typeof html !== 'string') {
    return '';
  }

  const withoutTags = html.replace(/<[^>]*>/g, '');

  const decoded = withoutTags
    .replace(/&nbsp;/g, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/&[a-zA-Z0-9#]+;/g, '');

  return decoded.replace(/\s+/g, ' ').trim();
};

/**
 * Check if a string contains valid text content after stripping HTML
 * @param html - HTML string to check
 * @returns True if there is valid text content
 */
export const hasValidTextContent = (html: string): boolean => {
  const cleanText = stripHtml(html);
  return cleanText.length > 0;
};
